// zh.js
const zh = {
  Address: '地址',
  Email: '邮箱',
  Fax: '传真',
  ViewMore: '查看更多',
  ViewAll: '查看全部',
  ViewDetails: '查看',
  View: '查看',
  Home: '首页',
  News: '新闻',
  CorrelationNews: '相关新闻',
  OrganizationalProfile: '组织概况',
  FoundationProject: '基金会项目',
  SpecialFund: '专项基金',
  KidsGallery: '儿童画廊',
  Download: '下载',
  ContactUs: '联系我们',
  PleaseInput: '请输入',
  FoundingSupportingInstitutionsFoundation: '基金会创始支持机构',
  CouncilMembers: '理事单位',
  FollowWeChatAccount: '关注官方微信',
  FollowWeiboAccount: '关注官方微博',
  FoundationIntroduction: '基金会简介',
  FoundingDirectorUnit: '创始理事单位',
  Council: '理事会',
  OrganizationStructure: '组织结构',
  PreviousArticle: '上一篇',
  NextArticle: '下一篇',
  noArticle:'没有了',
  FoundationPurpose: '基金会宗旨',
  FoundingInstitutionsFoundation: '基金会创始支持机构',
  CouncilMember: '理事会成员',
  FundIntroduction: '基金介绍',
  NewsInformation: '新闻资讯',
  Share: '分享',
  Foreword: '前言',
  Jury: '评审团',
  PrimaryGroup: '小学组',
  MiddleGroup: '中学组',
  Author: '作者',
};
export default zh;
